module.exports = __webpack_public_path__ + "img/archives-banner.27962da3.svg";